import base from 'components/base'
import componentInit from 'components/componentInit'
import cookies from 'js-cookie'
import $ from 'jquery'

class cookieNotice extends base
{
  elements = {
    container: null,
    closeButton: null
  }

  constructor(element)
  {
    super()

    this.elements.container = $(element).get(0)
    this.elements.closeButton = $(this.elements.container).children('button.close').get(0)

    this.bindEvents()
  }

  bindEvents()
  {
    $(this.elements.closeButton).on('click.'+ module.id, () =>
    {
      this.close()
    })
  }

  close()
  {
    $(this.elements.container).remove()
    cookies.set('cookieNoticeClosed', true, {
      domain: window.location.hostname,
      secure: window.location.protocol === 'https:',
      expires: 180 // days
    })
  }
}

componentInit.prototype.callbacks[module.id] = function(parentElement)
{
  let elements = $(parentElement).find('.cookie-notice').get()
  for(let element of elements)
    new cookieNotice(element)
}

export default cookieNotice



// WEBPACK FOOTER //
// ./vendor/response200/kustantajat/applications/publicFrontend/scripts/components/cookieNotice.js